import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { GuaranteeFundBannerSC } from './guarantee-fund-banner.styled';
import { BodyText, HeadingTwo, SmallText } from '../typography';
import Button from '../ui/button';
import FundDetail from './components/fund-detail/fund-detail';
import numeral from 'numeral';

function GuaranteeFundBanner({ total, used, free, history }) {
  return (
    <GuaranteeFundBannerSC>
      <div className="left-wrapper">
        <HeadingTwo className="white title">
          <FormattedHTMLMessage id="guarantee_fund_title" />
        </HeadingTwo>
        <BodyText className="white description">
          <FormattedHTMLMessage id="guarantee_fund_description" />
        </BodyText>
        <Button type="PRIMARY" onClick={() => history.push('/invest-manage/deposit')}>
          <FormattedMessage id="guarantee_fund_action" />
        </Button>
        <SmallText className="dark-grey note">
          <FormattedHTMLMessage id="guarantee_fund_action_note" />
        </SmallText>
      </div>
      <div className="right-wrapper">
        <FundDetail
          title={
            <FormattedMessage
              id="guarantee_fund_currency"
              values={{ value: numeral(free).format('0.00') }}
            />
          }
          label={
            <FormattedMessage
              id="guarantee_fund_free"
              values={{
                value: numeral((free / total) * 100).format('0.00') || 0,
              }}
            />
          }
          className="top"
        />
        <FundDetail
          title={
            <FormattedMessage
              id="guarantee_fund_currency"
              values={{ value: numeral(used).format('0.00') }}
            />
          }
          label={
            <FormattedMessage
              id="guarantee_fund_used"
              values={{
                value: numeral((used / total) * 100).format('0.00') || 0,
              }}
            />
          }
        />

        <FundDetail
          title={
            <FormattedMessage
              id="guarantee_fund_currency"
              values={{ value: numeral(total).format('0.00') }}
            />
          }
          label={<FormattedMessage id="guarantee_fund_total" />}
        />
      </div>
    </GuaranteeFundBannerSC>
  );
}

GuaranteeFundBanner.defaultProps = {
  total: 0,
  used: 0,
  free: 0,
};

export default withRouter(GuaranteeFundBanner);
